export default __webpack_public_path__ + "static/media/measurements.72d654be.png";